import type {
  CommunityPost,
  CommunityPostReportReason,
  CommunityPostsPage,
} from "@/types/community";
import { request } from "./transport";

export interface CommunityPostInput {
  body: string;
  client_token: string;
  visibility?: "public" | "private";
}

export const communityPosts = {
  react: (id: number, reaction: "like" | "dislike" | null) =>
    request<{ post: CommunityPost }>(`/community_posts/${id}/reaction`, {
      method: reaction === null ? "DELETE" : "PUT",
      ...(reaction === null ? {} : { body: JSON.stringify({ reaction }) }),
    }),
  bookmark: (id: number, saved: boolean) =>
    request<{ saved: boolean }>(`/community_posts/${id}/bookmark`, {
      method: saved ? "PUT" : "DELETE",
    }),
  listCommunityPosts: (params?: {
    authorId?: number;
    cursor?: string;
    limit?: number;
    scope?: "following" | "mine" | "saved" | "liked";
  }) => {
    const query = new URLSearchParams();
    if (params?.cursor) query.set("cursor", params.cursor);
    if (params?.limit) query.set("limit", String(params.limit));
    if (params?.scope) query.set("scope", params.scope);
    if (params?.authorId) query.set("author_id", String(params.authorId));
    const suffix = query.size > 0 ? `?${query.toString()}` : "";
    return request<CommunityPostsPage>(`/community_posts${suffix}`);
  },

  createCommunityPost: (input: CommunityPostInput) =>
    request<{ post: CommunityPost }>("/community_posts", {
      method: "POST",
      body: JSON.stringify({ post: input }),
    }),

  deleteCommunityPost: (id: number) =>
    request<{ ok: true }>(`/community_posts/${id}`, { method: "DELETE" }),

  updateCommunityPostVisibility: (
    id: number,
    visibility: "public" | "private",
  ) =>
    request<{ post: CommunityPost }>(`/community_posts/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ post: { visibility } }),
    }),

  updateCommunityPostBody: (id: number, body: string) =>
    request<{ post: CommunityPost }>(`/community_posts/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ post: { body } }),
    }),

  reportCommunityPost: (id: number, reason: CommunityPostReportReason) =>
    request<{ reported: true }>(`/community_posts/${id}/report`, {
      method: "POST",
      body: JSON.stringify({ reason }),
    }),
};
